import { RAW_COLORS } from '../colors';

export const LNB_THEME = {
  color: {
    bg: {
      normal: RAW_COLORS.bluegray50,
      selected: RAW_COLORS.blue50,
      hover: RAW_COLORS.bluegray150,
      selectedHover: RAW_COLORS.blue100,
    },
    divider: {
      default: RAW_COLORS.bluegray200,
    },
    content: {
      unSelected: RAW_COLORS.bluegray800,
      hover: RAW_COLORS.bluegray900,
      selected: RAW_COLORS.blue700,
      light: RAW_COLORS.bluegray700,
    },
  },
};